module.exports = __webpack_public_path__ + "media/church.044c01ec.ogg";